import { render } from "./TraiteurList.vue?vue&type=template&id=19638eba&ts=true"
import script from "./TraiteurList.vue?vue&type=script&lang=ts"
export * from "./TraiteurList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__